import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { Tab } from '../../interfaces/tab.interface';
import { AccountType } from '../../interfaces/api/AccountType';
import { ApiService, UserInfo } from '../../services/api.service'

@Component({
  selector: 'app-tabs',
  templateUrl: './tabs.component.html',
  styleUrl: './tabs.component.scss',
  standalone: true,
  imports: [CommonModule, TranslateModule]
})
export class TabsComponent {
  @Input() tabs: Tab[] = [];
  @Input() activeTab: string = '';
  @Input() textWrap: boolean = true;
  @Output() tabChanged = new EventEmitter<string>();
  userInfo: UserInfo;

  constructor(private api: ApiService) {}

  ngOnInit() {
      this.api.userInfo.subscribe(userInfo => this.userInfo = userInfo);
  }

  selectTab(tab: Tab): void {
    this.activeTab = tab.value;
    this.tabChanged.emit(tab.value);
  }

  isActive(tab: Tab): boolean {
    return this.activeTab === tab.value;
  }

  protected readonly AccountType = AccountType
} 